import {ITEM_TYPE} from '@PosterWhiteboard/items/item/item.types';
import {useAppSelector} from '@/hooks';

export function usePosterHasMenuItem(): boolean {

  return useAppSelector((state): boolean => {
    const items = state.posterEditor.posterObject?.pages.pagesHashMap[state.posterEditor.currentPageId]?.items.itemsHashMap;
    if (items) {
      for (const item of Object.values(items)) {
        if (item.gitype === ITEM_TYPE.MENU) {
          return true;
        }
      }
    }
    return false;
  });
}